import { HealthResponseSchema, type HealthResponse } from '../../src/shared/health';

/**
 * Fetch and validate `GET /api/health`. Parsing through the shared zod schema means
 * a contract drift between Worker and SPA fails loudly here rather than silently
 * rendering garbage (ARCHITECTURE_PLAN §3). The health endpoint predates the §9
 * envelope and returns its payload directly (no `{ ok, data }` wrapper).
 *
 * @param init.fetchImpl injectable fetch for tests; defaults to the global.
 * @param init.signal    React Query cancellation signal.
 */
export async function fetchHealth(init?: {
  fetchImpl?: typeof fetch;
  signal?: AbortSignal;
}): Promise<HealthResponse> {
  const fetchImpl = init?.fetchImpl ?? fetch;
  const response = await fetchImpl('/api/health', {
    headers: { accept: 'application/json' },
    ...(init?.signal !== undefined ? { signal: init.signal } : {}),
  });
  const json: unknown = await response.json();
  return HealthResponseSchema.parse(json);
}
